export interface Sidebar {
    bizInfo: BizInfo;
    menuItems: SidebarItem[];
    menuOpen: boolean;
    expandedItem: string | null;
}

export interface Option {
    label: string;
    url: string;
}

export enum MenuItemType {
    // eslint-disable-next-line no-unused-vars
    BUTTON = 'button',
    // eslint-disable-next-line no-unused-vars
    CATEGORY = 'category',
    // eslint-disable-next-line no-unused-vars
    DIVIDER = 'divider'
}

export interface SidebarItem {
    title: string;
    icon?: React.ReactNode;
    to?: string;
    menuType?: MenuItemType;
    options?: SidebarItem[];
    onClick?: () => void;
}

export interface SidebarProps {
    menuItems: SidebarItem[];
    menuOpen: boolean;
}

export interface ExpandedSidebarProps {
    menuItems: SidebarItem[];
    expandedItem: string | null;
    onClose: () => void;
}

export interface BizInfo {
    companyId: string;
    companyName: string;
    period: number;
    startDate: Date;
    endDate: Date;
}

